import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import { getGroupChannelDetails } from "../../../services/groupService";

import "./index.scss";

export default function ChannelChip({ groupId, channel, onClick, className }) {
    const [hovered, setHovered] = useState(false);
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const chipRef = useRef(null);
    const [pos, setPos] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (!hovered) return;
        const rect = chipRef.current?.getBoundingClientRect();
        if (rect) {
            setPos({ top: rect.bottom + 8, left: rect.left });
        }
        if (!details && !loading && groupId && channel?.id) {
            setLoading(true);
            getGroupChannelDetails(groupId, channel.id)
                .then((d) => setDetails(d))
                .catch(() => {})
                .finally(() => setLoading(false));
        }
    }, [hovered, details, loading, groupId, channel?.id]);

    const label = `#${channel?.slug || channel?.name || "channel"}`;
    const isPrivate = Boolean(channel?.privateChannel);

    return (
        <>
            <button
                ref={chipRef}
                type="button"
                className={classNames("channel-chip", isPrivate && "channel-chip--private", className)}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick?.(channel);
                }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <span className="channel-chip__hash">#</span>
                <span className="channel-chip__slug">{channel?.slug}</span>
            </button>
            {hovered && (
                <div
                    className="channel-hovercard"
                    style={{ position: "fixed", top: pos.top, left: pos.left }}
                    role="tooltip"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    <header className="channel-hovercard__header">
                        <strong>{label}</strong>
                    </header>
                    <p className="channel-hovercard__desc">
                        {details?.description || channel?.description || "Channel for team collaboration"}
                    </p>
                    <footer className="channel-hovercard__meta">
                        <span>{details?.memberCount != null ? `${details.memberCount} members` : (isPrivate ? "Private" : "Open")}</span>
                    </footer>
                </div>
            )}
        </>
    );
}

ChannelChip.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channel: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        slug: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        privateChannel: PropTypes.bool,
    }).isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

